import { Button, Checkbox, FormControlLabel, Grid, TextareaAutosize, TextField } from "@material-ui/core";
import React, { useEffect } from 'react';
import { trackPromise } from "react-promise-tracker";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { onError } from "src/store/actions/popupActions";
import { INTERNAL_BILATERAL_CONTRACT_NOTIFICATION_CHANGE, INTERNAL_BILATERAL_CONTRACT_RETRIEVED } from "src/store/InternalBilateral/InternalBilateralActionTypes";
import { cleanStringInput } from "src/Utility/StringUtil";
import axios from "../../../axios/AxiosInterceptors";

const ContractDetails = (props) => {

    const params = useParams();
    const dispatch = useDispatch();
    const selectedContract = useSelector(state => state.internalBilateral.selectedContract);

    useEffect(() => {
        retrieveContract();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params, props.contractId])

    const retrieveContract = async () => {
        if (props.contractId) {
            await trackPromise(axios.get("/inschedule/v2/account/" + params.accountId + "/contract/" + props.contractId).then(response => {
                if (response && response.data) {
                    dispatch({ type: INTERNAL_BILATERAL_CONTRACT_RETRIEVED, selectedContract: response.data })
                }
            }).catch(error => {
                dispatch(onError(error.response));
            }))
        }
    }

    const notifyNewSchedulesChange = () => {
        let contract = selectedContract;
        contract.notifyNewSchedules = !contract.notifyNewSchedules;
        dispatch({ type: INTERNAL_BILATERAL_CONTRACT_NOTIFICATION_CHANGE, inscheduleContract: { ...contract } });
    }

    const updateContract = async () => {
        await trackPromise(axios.put("/inschedule/v2/account/" + selectedContract.accountId + "/contract/" + selectedContract.id, JSON.stringify(selectedContract)).then(response => {
            dispatch({ type: INTERNAL_BILATERAL_CONTRACT_RETRIEVED, selectedContract: response.data })
        }).catch(error => {
            dispatch(onError(error.response));
        }))
    }

    return (
        <Grid container spacing={2}>
            <Grid item xs={6} sm={2}>
                <TextField name="pjmContractId" label="PJM Contract Id" value={cleanStringInput(selectedContract.contractId)} disabled={true} fullWidth />
            </Grid>
            <Grid item xs={6} sm={1} />
            <Grid item xs={6} sm={2}>
                <TextField name="contractName" label="Contract Name" value={cleanStringInput(selectedContract.contractName)} disabled={true} fullWidth />
            </Grid>
            <Grid item xs={6} sm={1} />
            <Grid item xs={6} sm={2}>
                <TextField name="pricing" label="Pricing" value={cleanStringInput(selectedContract.dayAhead) ? "Day Ahead" : "Real Time"} disabled={true} fullWidth />
            </Grid>
            <Grid item xs={6} sm={1} />
            <Grid item xs={6} sm={2}>
                <TextField name="serviceType" label="Service Type" value={cleanStringInput(selectedContract.serviceType)} disabled={true} fullWidth />
            </Grid>
            <Grid item xs={6} sm={1} />
            <Grid item xs={6} sm={2}>
                <TextField name="startDate" label="Start Date" value={cleanStringInput(selectedContract.startDate)} disabled={true} fullWidth />
            </Grid>
            <Grid item xs={6} sm={1} />
            <Grid item xs={6} sm={2}>
                <TextField name="endDate" label="End Date" value={cleanStringInput(selectedContract.endDate)} disabled={true} fullWidth />
            </Grid>
            <Grid item xs={6} sm={1} />
            <Grid item xs={6} sm={2}>
                <TextField name="pendingEndDate" label="Pending End Date" value={cleanStringInput(selectedContract.pendingStopDate)} disabled={true} fullWidth
                />
            </Grid>
            <Grid item xs={6} sm={1} />
            <Grid item xs={6} sm={2}>
                <TextField name="scheduleConfirmationType" label="Schedule Confirmation" value={cleanStringInput(selectedContract.scheduleConfirmationType)} disabled={true} fullWidth />
            </Grid>
            <Grid item xs={6} sm={1} />
            <Grid item xs={6} sm={2}>
                <TextField name="source" label="Source" value={cleanStringInput(selectedContract.source)} disabled={true} fullWidth />
            </Grid>
            <Grid item xs={6} sm={1} />
            <Grid item xs={6} sm={2}>
                <TextField name="sink" label="Sink" value={cleanStringInput(selectedContract.sink)} disabled={true} fullWidth />
            </Grid>
            <Grid item xs={6} sm={1} />
            <Grid item xs={6} sm={2}>
                <TextField name="seller" label="Seller" value={cleanStringInput(selectedContract.sellerName)} disabled={true} fullWidth />
            </Grid>
            <Grid item xs={6} sm={1} />
            <Grid item xs={6} sm={2}>
                <TextField name="buyer" label="Buyer" value={cleanStringInput(selectedContract.buyerName)} disabled={true} fullWidth />
            </Grid>
            <Grid item xs={6} sm={8}>
                <TextareaAutosize minRows={3} defaultValue={cleanStringInput(selectedContract.comments)} disabled={true} style={{ width: "100%" }} />
            </Grid>
            <Grid item xs={6} sm={1} />
            <Grid item xs={6} sm={3}>
                <FormControlLabel control={<Checkbox onChange={notifyNewSchedulesChange} checked={selectedContract.notifyNewSchedules} />} label="Send New Schedule Notifications" />
            </Grid>
            <Grid item xs={6} sm={4} />
            <Grid item xs={6} sm={4}>
                <Button onClick={updateContract}>Update Contract</Button>
            </Grid>
            <Grid item xs={6} sm={4} />
        </Grid>
    )
}

export default ContractDetails;